import React, { useEffect, useState } from "react";
import Button from "src/components/common/Button";
import Loader from "src/components/common/loaders";
import { NOT_AUTHORIZED_TEXT } from "src/constant/global";
import { isAddAccess } from "src/helpers";
import { errorAlert } from "src/utils/alerts";
import customAxios from "src/utils/axios";
import AddCoupon from "./add-coupon";
import CouponsList from "./coupons-list";
import EditCoupon from "./edit-coupon";

const CouponManagement = () => {
  const [addNew, setAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [couponToEdit, setCouponToEdit] = useState();

  useEffect(() => {
    fetchCoupons();
  }, [addNew, edit]);

  const fetchCoupons = () => {
    setLoading(true);
    customAxios
      .get(`admin/list-coupons`)
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          setLoading(false);
          setCoupons(res?.data?.data?.result);
        }
      })
      .catch((error) => {
        setLoading(false);
        const message =
          error.response && error.response.data
            ? error.response.data.message
            : "Something Went Wrong";
        errorAlert(message);
      });
  };

  return (
    <>
      {!addNew && !edit && (
        <div className="main-div">
          <div className="heading">
            <div className="title">
              <h6 className="fw600">Coupon Management</h6>
            </div>

            <div className="ml-div">
              <div>
                <Button
                  text=" ADD NEW"
                  onHandleClick={() => {
                    const isAdd = isAddAccess("COUPON_MANAGEMENT");
                    if (isAdd) {
                      setAddNew(true);
                    } else {
                      errorAlert(NOT_AUTHORIZED_TEXT);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          {loading && <Loader />}

          <CouponsList
            list={coupons}
            fetchCoupons={fetchCoupons}
            setCouponToEdit={(item) => {
              setCouponToEdit(item);
              setEdit(true);
            }}
          />
        </div>
      )}
      {addNew && <AddCoupon setAddNew={setAddNew} />}

      {edit && <EditCoupon setEdit={setEdit} couponToEdit={couponToEdit} />}
    </>
  );
};

export default CouponManagement;
